import { VerificationServicesState } from "@idw-types/state/verification-services-state";
import { FormattedVerificationServiceConfiguration } from "@idw-types/data/verification-service-configuration";
import { VerificationServicesActionTypes, VerificationServicesActions } from "../actions/verification-services-actions";

export const initialVerificationServicesState: VerificationServicesState = {
    verificationServiceConfigurations: {
        verificationServiceConfigurations: null,
        isLoading: false
    }
}

export const verificationServicesReducer = (
    state: VerificationServicesState = initialVerificationServicesState,
    action: VerificationServicesActions
): VerificationServicesState => {
    switch (action.type) {
        // Services
        case VerificationServicesActionTypes.SET_VERIFICATION_SERVICE_CONFIGURATIONS_LOADING:
            return {
                ...state,
                verificationServiceConfigurations: {
                    ...(action.payload.isLoading
                        ? { ...initialVerificationServicesState.verificationServiceConfigurations }
                        : { ...state.verificationServiceConfigurations }),
                    isLoading: action.payload.isLoading
                }
            };
        case VerificationServicesActionTypes.SET_VERIFICATION_SERVICE_CONFIGURATIONS:
            return {
                ...state,
                verificationServiceConfigurations: {
                    verificationServiceConfigurations: action.payload.verificationServiceConfigurations,
                    isLoading: false
                }
            };
        case VerificationServicesActionTypes.REPLACE_VERIFICATION_SERVICE_CONFIGURATION:
            return {
                ...state,
                verificationServiceConfigurations: {
                    ...state.verificationServiceConfigurations,
                    verificationServiceConfigurations: replaceVerificationServiceConfiguration(
                        state.verificationServiceConfigurations.verificationServiceConfigurations,
                        action.payload.verificationServiceConfiguration
                    )
                }
            };
        case VerificationServicesActionTypes.REMOVE_VERIFICATION_SERVICE_CONFIGURATION:
            return {
                ...state,
                verificationServiceConfigurations: {
                    ...state.verificationServiceConfigurations,
                    verificationServiceConfigurations: removeVerificationServiceConfiguration(
                        state.verificationServiceConfigurations.verificationServiceConfigurations,
                        action.payload.verificationServiceConfiguration
                    )
                }
            };
        default:
            return state;
    }
};

const replaceVerificationServiceConfiguration = (
    verificationServiceConfigurations: Array<FormattedVerificationServiceConfiguration>,
    newVerificationServiceConfiguration: FormattedVerificationServiceConfiguration
) => {
    return verificationServiceConfigurations.map(config => config.id === newVerificationServiceConfiguration.id ? newVerificationServiceConfiguration : config);
};

const removeVerificationServiceConfiguration = (
    verificationServiceConfigurations: Array<FormattedVerificationServiceConfiguration>,
    vcToRemove: FormattedVerificationServiceConfiguration
) => {
    return verificationServiceConfigurations.filter(config => config.id !== vcToRemove.id);
};